/* import __COLOCATED_TEMPLATE__ from './auth-app.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { getOwner } from '@ember/application';
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { MarketQRCodeEncoder } from '@square/qrcode-encoder';
export const CONSTANTS = {
  DEFAULT_TWO_FACTOR_HELP_URL: '/help/en/us/article/5593-2-step-verification'
};
let TwoFactorEnrollAuthAppComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), (_class = class TwoFactorEnrollAuthAppComponent extends Component {
  get twoFactorHelpUrl() {
    return this.args.twoFactorHelpUrl || CONSTANTS.DEFAULT_TWO_FACTOR_HELP_URL;
  }
  get formattedManualQrCode() {
    if (!this.multipassfeClient.googleAuthDetails?.authenticator_key_base32) {
      return '';
    }
    return this.multipassfeClient.googleAuthDetails?.authenticator_key_base32.match(/.{1,4}/g).join('  ');
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "locale", _descriptor, this);
    _initializerDefineProperty(this, "logger", _descriptor2, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor3, this);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "views", Object.freeze({
      QR_CODE: 'QR_CODE',
      MANUAL: 'MANUAL'
    }));
    _initializerDefineProperty(this, "view", _descriptor4, this);
    _initializerDefineProperty(this, "initializingAuthAppEnrollSecret", _descriptor5, this);
    this.config = getOwner(this).resolveRegistration('config:environment');
    this.initializeQrCodeView();
  }
  displayQrCode(code) {
    const output = document.getElementById('auth-app-qr-output');
    output.innerHTML = code.svg;
  }
  async initializeQrCodeView() {
    this.view = this.views.QR_CODE;
    if (!this.multipassfeClient.googleAuthDetails?.authenticator_key_base32) {
      try {
        this.initializingAuthAppEnrollSecret = true;
        await this.multipassfeClient.enrollTwoFactorGoogleAuthenticator();
      } catch (e) {
        this.logger.error('Failed to initialize auth app enroll flow', e);
      } finally {
        this.initializingAuthAppEnrollSecret = false;
      }
    }
    // Run after this.view change causes re-render to allow targeting qr element
    later(this, () => {
      const code = new MarketQRCodeEncoder(this.multipassfeClient.googleAuthDetails?.authenticator_key_uri, {
        border: false,
        styleBackground: ''
      });
      this.displayQrCode(code);
    });
  }
  setView(view) {
    this.view = view;
  }
  detailSelected(event) {
    if (event.detail.newSelectionValue) {
      this.args.setDetail(event.detail.newSelectionValue);
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "locale", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "view", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.views.QR_CODE;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "initializingAuthAppEnrollSecret", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "initializeQrCodeView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeQrCodeView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "detailSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "detailSelected"), _class.prototype)), _class));
export { TwoFactorEnrollAuthAppComponent as default };